module.exports = __webpack_public_path__ + "static/img/soldout.2a208fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/suitMode/soldout.svg
// module id = ccDp
// module chunks = 1